module.exports = __webpack_public_path__ + "static/media/indian-flag.f3a60ba3.svg";